import React, { useContext, useEffect, useState } from "react";
import _ from "lodash";

import { useTheme } from "@mui/material/styles";

import Popup from "./Popup";
import {
  CircularProgress,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Select,
  MenuItem,
  DialogActions,
  Button,
  InputLabel,
  FormControl,
} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

import AlertDialog from "../Dialogs/AlertDialog";

import HttpContext from "../../contexts/HTTP/HttpContext";
import ImageContext from "../../contexts/Image/ImageContext";
import ModelContext from "../../contexts/Model/ModelContext";

import useServerUpload from "../../hooks/useServerUpload";

function Thumbnail(props) {
  const theme = useTheme();
  const { get } = useContext(HttpContext);
  const { setImageData } = useContext(ImageContext);
  const { models } = useContext(ModelContext);

  const { size, imageData } = props;

  const { handleServerUrlUpload } = useServerUpload();

  const [showPopup, setShowPopup] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  const [uploadModel, setUploadModel] = useState({});
  const [showUploadDialog, setShowUploadDialog] = useState(false);
  const [showUploadStartedDialog, setShowUploadStartedDialog] = useState(false);

  const [model, setModel] = useState({});

  const handlePopupClick = () => {
    if (imageData.processing) return;

    setShowPopup(true);
  };

  const handleDelete = async () => {
    const imageId = imageData._id;

    const res = await get("/deleteImage", { imageId });
    if (res.status === 200) {
      setImageData((imageData) => {
        const updatedImageData = _.cloneDeep(imageData);

        _.remove(updatedImageData.raw, { _id: imageId });
        _.remove(updatedImageData.processed, { _id: imageId });

        return updatedImageData;
      });
    }
  };

  const handleUpload = async () => {
    const url = _.get(imageData, "file");

    if (!uploadModel || !url) return;

    handleServerUrlUpload(url, uploadModel);

    setShowUploadStartedDialog(true);
  };

  useEffect(() => {
    const modelId = _.get(imageData, "model", "");
    const model = _.find(models, { _id: modelId });

    if (!model) {
      return;
    }

    setModel(model);
    setUploadModel(model);
  }, [models]);

  return (
    <div style={{ position: "relative" }}>
      <img
        src={imageData.file}
        onClick={handlePopupClick}
        style={{
          padding: 4,
          borderStyle: "solid",
          borderColor: "lightgrey",
          borderWidth: "1px",
          height: size,
          width: size,
          minHeight: "135px",
          minWidth: "135px",
          margin: theme.spacing(0.5),
          objectFit: "contain",
          cursor: imageData.processing ? "default" : "pointer",
          opacity: imageData.processing ? 0.2 : 1,
        }}
      />
      {imageData.processing && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10,
          }}
        >
          <CircularProgress />
        </div>
      )}
      {!imageData.processing && (
        <>
          <div
            style={{
              position: "absolute",
              top: 16,
              left: 8,
              zIndex: 10,
              cursor: "pointer",
              fontSize: "12px",
              backgroundColor: "white",
              padding: 2,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {imageData.type === "processed" && (
              <>
                <div
                  style={{
                    height: "12px",
                    width: "12px",
                    borderRadius: "50%",
                    backgroundColor: _.get(model, "color", "#000"),
                    marginRight: theme.spacing(0.5),
                  }}
                />
                {_.get(model, "displayName", "Unknown")}
              </>
            )}
          </div>
          <div
            style={{
              position: "absolute",
              top: 8,
              right: 8,
              zIndex: 10,
              cursor: "pointer",
              color: "grey",
            }}
            onClick={() => setShowDeleteDialog(true)}
          >
            <HighlightOffIcon />
          </div>
        </>
      )}
      <Popup
        open={showPopup}
        imageData={imageData}
        handleClose={() => setShowPopup(false)}
        handleShowUploadDialog={() => setShowUploadDialog(true)}
      />
      <AlertDialog
        open={showDeleteDialog}
        handleConfirm={handleDelete}
        handleClose={() => setShowDeleteDialog(false)}
        title="Delete this image?"
      >
        <Typography style={{ marginBottom: theme.spacing(2) }}>
          Are you sure you want to delete this image?
        </Typography>
      </AlertDialog>
      <AlertDialog
        open={showUploadStartedDialog}
        handleClose={() => setShowUploadStartedDialog(false)}
        title="Image Uploaded"
      >
        <Typography style={{ marginBottom: theme.spacing(2) }}>
          Your image has been sent for processing. You can monitor your images
          upload progress from the Home page.
        </Typography>
      </AlertDialog>
      <Dialog
        open={showUploadDialog}
        onClose={() => setShowUploadDialog(false)}
        style={{ zIndex: 1000 }}
      >
        <DialogTitle>Re-Process Image</DialogTitle>
        <DialogContent style={{ display: "flex", flexDirection: "column" }}>
          <FormControl style={{ marginTop: theme.spacing(1) }}>
            <InputLabel id="model-reupload-selection">Model</InputLabel>
            <Select
              labelId="model-reupload-selection"
              id="model-reupload-selection"
              value={uploadModel}
              label="Model"
              onChange={(e) => setUploadModel(e.target.value)}
              MenuProps={{ style: { zIndex: 1010 } }}
            >
              {models.map((model) => (
                <MenuItem value={model}>{model.displayName}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleUpload}>Submit</Button>
          <Button color="secondary" onClick={() => setShowUploadDialog(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Thumbnail;
